<footer id="footerId" class="footer">
  <div class="wrap_copy">
    <a class="navbar-brand" href="javascript:void(0)" routerLink="/kr/home" [routerLinkActive]="['router-link-active']" class="logo">
      <img src="../../../assets/images/logo.png" width="180px" />
    </a>
    <div class="info">
      <ul class="menu">
        <li>
          <a [routerLink]="['/kr/about/', 0]"> 플랫폼 소개 </a>
        </li>
        <li>
          <a href="javascript:void(0)" routerLink="/kr/tos" [routerLinkActive]="['router-link-active']"> 사이트이용약관 </a>
        </li>
        <li>
          <a href="javascript:void(0)" routerLink="/kr/privacy" [routerLinkActive]="['router-link-active']"> 개인정보처리방침 </a>
        </li>
        <li>
          <a href="javascript:void(0)" routerLink="/kr/membership-terms" [routerLinkActive]="['router-link-active']"> 멤버십 약관 </a>
        </li>
      </ul>
      <p class="footer_info">
        <span>(주)더좋은운동으로</span> | <span>대표 : 서남현</span>&nbsp; <span>사업자등록번호 : 279-81-01114</span><br />
        <span>통신판매업신고번호 : 제 2019-인천연수구-0267호</span>&nbsp;| <span>개인정보책임자 : (주)더좋은운동으로</span><br />
        <span>주소 : 인천 연수구 컨벤시아대로 204 인스타1 302호</span>&nbsp;| <span>Tel : 032-459-2220 | Fax : 032-459-2221</span><br />
        <!-- <span>대구 · 경북지점 : 경상북도 안동시 문화광장길 50, 4층(삼산동)</span>&nbsp;| <span>Tel : 054-858-7882 | Fax : 050-7089-3857</span><br /> -->
        <span>Copyright (c) T-BOX MEDIA. All Rights Reserved.</span>&nbsp;
        <span>E-mail : tboxtop&#64;tbox.media</span>
      </p>
    </div>
  </div>
</footer>
